import axios from 'axios';
import qs from 'qs';

import { removeEmptyProperties, convertArrayToString } from '../shared/utils';

class API {
    constructor(axios, qs, token) {
        this.request = axios;
        this.qs = qs;
        this.baseUrl = process.env.REACT_APP_HOST && process.env.REACT_APP_PORT
            ? `${process.env.REACT_APP_HOST}:${process.env.REACT_APP_PORT}/api/`
            // : 'https://financeiro-diogonc.brazilsouth.cloudapp.azure.com/api/';
             //: 'http://financeiro-api.innitisoftware.com.br/api/';
              : 'http://localhost:3000/api/';
        this.token = token;
    }

    setToken(token) {
        this.token = token;
    }

    async login(email, password) {
        try {
            return await this.postRequest('account/login', {
                email,
                password
            });
        } catch (error) {
            throw (error);
        }
    }

    async register(name, email, password, passwordConfirmation) {
        try {
            return await this.postRequest('account/register', {
                email,
                password,
                passwordConfirmation,
                username: email,
                name: name
            });
        } catch (error) {
            throw (error);
        }
    }

    //group
    async loadGroup(filters) {
        try {
            let processedFilters = filters;
            if (!!filters && !!filters.type && filters.type === 'all') {
                // Create a copy of filters and exclude the 'type' property
                processedFilters = { ...filters };
                delete processedFilters.type;
            }
            return await this.getRequest('groups/', processedFilters);
        } catch (error) {
            throw (error);
        }
    }

    async addGroup(item) {
        try {
            return await this.postRequest('groups/', item);
        } catch (error) {
            throw (error);
        }
    }

    async updateGroup(item) {
        try {
            return await this.putRequest(`groups/${item.id}`, item);
        } catch (error) {
            throw (error);
        }
    }

    async deleteGroup(id) {
        try {
            return await this.deleteRequest(`groups/${id}`);
        } catch (error) {
            throw (error);
        }
    }

    //account
    async loadAccount(filters) {
        try {
            let queryFilters = filters;
            if (!!filters && !!filters.userId && filters.userId === 'all') {
                // Create a copy to avoid mutating the original object
                queryFilters = { ...filters };
                delete queryFilters.userId;
            }

            return await this.getRequest('accounts/', queryFilters);
        } catch (error) {
            throw (error);
        }
    }

    async addAccount(item) {
        try {
            return await this.postRequest('accounts/', item);
        } catch (error) {
            throw (error);
        }
    }

    async updateAccount(item) {
        try {
            return await this.putRequest(`accounts/${item.id}`, item);
        } catch (error) {
            throw (error);
        }
    }

    async deleteAccount(id) {
        try {
            return await this.deleteRequest(`accounts/${id}`);
        } catch (error) {
            throw (error);
        }
    }

    //category
    async loadCategory(filters) {
        try {
            let queryFilters = filters;
            if (!!filters && !!filters.userId && filters.userId === 'all') {
                // Create a copy to avoid mutating the original object
                queryFilters = { ...filters };
                delete queryFilters.userId;
            }

            return await this.getRequest('categories/', queryFilters);
        } catch (error) {
            throw (error);
        }
    }

    async addCategory(item) {
        try {
            return await this.postRequest('categories/', item);
        } catch (error) {
            throw (error);
        }
    }

    async updateCategory(item) {
        try {
            return await this.putRequest(`categories/${item.id}`, item);
        } catch (error) {
            throw (error);
        }
    }

    async deleteCategory(id) {
        try {
            return await this.deleteRequest(`categories/${id}`);
        } catch (error) {
            throw (error);
        }
    }

    //transaction
    async loadTransaction(filters) {
        try {
            let queryFilters = filters;
            if (!!filters && !!filters.userId && filters.userId === 'all') {
                // Create a copy to avoid mutating the original object
                queryFilters = { ...filters };
                delete queryFilters.userId;
            }

            return await this.getRequest('transactions/', queryFilters);
        } catch (error) {
            throw (error);
        }
    }

    async loadTransactionByFile(uploadedFile) {
        try {
            return await this.postRequestWithAttachment('transactions/file', {file: uploadedFile});
        } catch (error) {
            throw (error);
        }
    }

    async addTransaction(item) {
        try {
            return await this.postRequestWithAttachment('transactions/', item);
        } catch (error) {
            throw (error);
        }
    }

    async updateTransaction(item) {
        try {
            return await this.putRequestWithAttachment(`transactions/${item.id}`, item);
        } catch (error) {
            throw (error);
        }
    }

    async deleteTransaction(id) {
        try {
            return await this.deleteRequest(`transactions/${id}`);
        } catch (error) {
            throw (error);
        }
    }

    async deleteTransactionAttachment(id) {
        try {
            return await this.deleteRequest(`transactions/${id}/attachment`);
        } catch (error) {
            throw (error);
        }
    }    

    //users
    async loadUsers() {
        try {
            return await this.getRequest('users/');
        } catch (error) {
            throw (error);
        }
    }

    //reports
    async loadBalancePerAccount(filters) {
        try {
            let queryFilters = filters;
            if (!!filters && !!filters.userId && filters.userId === 'all') {
                // Create a copy to avoid mutating the original object
                queryFilters = { ...filters };
                delete queryFilters.userId;
            }
            return await this.getRequest('reports/balance-per-account', queryFilters);
        } catch (error) {
            throw (error);
        }
    }

    async loadBalancePerCategory(filters) {
        try {
            let queryFilters = filters;
            if (!!filters && !!filters.userId && filters.userId === 'all') {
                // Create a copy to avoid mutating the original object
                queryFilters = { ...filters };
                delete queryFilters.userId;
            }
            return await this.getRequest('reports/balance-per-category', queryFilters);
        } catch (error) {
            throw (error);
        }
    }

    async loadFutureBalance(filters) {
        try {
            let queryFilters = filters;
            if (!!filters && !!filters.userId && filters.userId === 'all') {
                // Create a copy to avoid mutating the original object
                queryFilters = { ...filters };
                delete queryFilters.userId;
            }
            return await this.getRequest('reports/current-income', queryFilters);
        } catch (error) {
            throw (error);
        }
    }

    async postRequest(path, data) {
        try {
            const header = _getHeaderWithToken();
            const result = await this.request.post(this.baseUrl + path, data, header);
            return result.data;
        } catch (error) {
            if (!!error && !!error.response && !!error.response.data && !!error.response.data.message) {
                const validationError = new Error(error.response.data.message);
                validationError.type = 'validation';
                throw validationError;
            }
            else throw (error);
        }
    }

    async postRequestWithAttachment(path, data) {
        try {
            const header = _getHeaderWithToken();
            const formData = new FormData();
            for (const key in data) {
                formData.append(key, data[key]);
            }
            const result = await this.request.post(this.baseUrl + path, formData, header);
            return result.data;
        } catch (error) {
            if (!!error && !!error.response && !!error.response.data && !!error.response.data.message) {
                const validationError = new Error(error.response.data.message);
                validationError.type = 'validation';
                throw validationError;
            }
            else throw (error);
        }
    }

    async putRequest(path, data) {
        try {
            const header = _getHeaderWithToken();
            const result = await this.request.put(this.baseUrl + path, data, header);
            return result.data;
        } catch (error) {
            if (!!error && !!error.response && !!error.response.data && !!error.response.data.message) {
                const validationError = new Error(error.response.data.message);
                validationError.type = 'validation';
                throw validationError;
            }
            else throw (error);
        }
    }

    async putRequestWithAttachment(path, data) {
        try {
            const header = _getHeaderWithToken();
            const formData = new FormData();
            for (const key in data) {
                formData.append(key, data[key]);
            }
            const result = await this.request.put(this.baseUrl + path, formData, header);
            return result.data;
        } catch (error) {
            if (!!error && !!error.response && !!error.response.data && !!error.response.data.message) {
                const validationError = new Error(error.response.data.message);
                validationError.type = 'validation';
                throw validationError;
            }
            else throw (error);
        }
    }


    async deleteRequest(path, data) {
        try {
            const header = _getHeaderWithToken();
            const result = await this.request.delete(this.baseUrl + path, header);
            return result.data;
        } catch (error) {
            if (!!error && !!error.response && !!error.response.data && !!error.response.data.message) {
                const validationError = new Error(error.response.data.message);
                validationError.type = 'validation';
                throw validationError;
            }
            else throw (error);
        }
    }

    async getRequest(path, data) {
        try {
            const header = _getHeaderWithToken();
            const queryString = this.qs.stringify(removeEmptyProperties(convertArrayToString(data)));
            const result = await this.request.get(this.baseUrl + path + '?' + queryString, { ...header });
            return result.data;
        } catch (error) {
            if (!!error && !!error.response && !!error.response.data && !!error.response.data.message) {
                const validationError = new Error(error.response.data.message);
                validationError.type = 'validation';
                throw validationError;
            }
            else throw (error);
        }
    }
}

const api = new API(axios, qs);
export default api;

function _getHeaderWithToken() {
    const account = JSON.parse(localStorage.getItem('account'));
    if (!!account && !!account.token) {
        return { headers: { Authorization: `JWT  ${account.token}` } };
    }
    return null;
}
